import React from "react";

/**
 * Dynamic SVG progress ring component for rendering session attendance metrics.
 *
 * NOTE ON EXLYIMAGE: ExlyImage (or standard <img> elements) cannot be used here because
 * this component calculates dynamic SVG stroke properties programmatically at runtime
 * (e.g. strokeDasharray={`${pct}, 100`}) to render an interactive progress gauge,
 * rather than displaying static image files or raster/vector image assets.
 *
 * @param {Object} props Component props.
 * @param {number} props.pct Attendance percentage number (0 to 100).
 * @param {string} props.strokeColorClass Tailwind CSS text color class for the stroke ring.
 */
export const AttendanceRingSVG = ({ pct, strokeColorClass }) => (
  <svg
    className="tw-w-full tw-h-full tw-transform -tw-rotate-90"
    viewBox="0 0 36 36"
  >
    <path
      className="tw-text-gray-200"
      strokeWidth="3.5"
      stroke="currentColor"
      fill="none"
      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      className={strokeColorClass}
      strokeDasharray={`${pct}, 100`}
      strokeWidth="3.5"
      strokeLinecap="round"
      stroke="currentColor"
      fill="none"
      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
    />
  </svg>
);
